import React, { useContext, useState } from 'react'
import useFetch from '../../hooks/useFetch'
import { __ } from 'i18n-for-browser'
import '../../config/i18n'

import SyntaxHighlighter from 'react-syntax-highlighter'
import { atomOneDark } from 'react-syntax-highlighter/dist/esm/styles/hljs'

import Button from '@react/react-spectrum/Button'
import Pagination from '@react/react-spectrum/Pagination'
import { success } from '@react/react-spectrum/Toast'

import { SkycityContext } from '../../lib/SkycityProvider'

import { downloadFile, copyText, getCodeLineToken, getCodeLineApiKey } from '../../lib/skycity.js'

export default function CodeSnippetColligo ({
    language,
    style = atomOneDark,
    lineNumberStyle = { color: 'rgba(112, 112, 112, 0.8)' },
    showLineNumbers = true
}) {
    const {
        codes,
        inputFiles
    } = useContext(SkycityContext)

    const [currentPage, setPage] = useState(1)
    let textFile = null
    const url = createCode(codes)
    const text = useFetch({ url, defaultValue: '', json: false })

    function getSyncCurl () {
        let text = 'curl --location --request $method -H "Authorization: Bearer $token" -H "Content-Type:multipart/form-data" -H "x-api-key: $apiKey" --form "request=$payload" --form "input_image=@local_image.png" "$endpoint" -i > out.txt\n'
        text += 'echo "Response output saved to file `pwd`/out.txt"'
        return text
    }

    // text += `\n`;
    function createCode (codes) {
        if (codes && codes.length > 0) {
            let text = '#!/bin/bash\n\n'
            text += '# ************************************\n'
            text += '# Check if jq is installed\n'
            text += '# ************************************\n'
            text += 'if [ ! `which jq` ]; then\n'
            text += '\techo "************************************"\n'
            text += '\techo "Please install jq: brew install jq"\n'
            text += '\techo "************************************"\n'
            text += '\texit 1\n'
            text += 'fi\n\n'
            text += '# ************************************\n'
            text += '# Set variables\n'
            text += '# ************************************\n'
            text += '# set -x\n'
            text += `${getCodeLineToken()}`
            text += `${getCodeLineApiKey(process.env.REACT_APP_CONFIG_APP_KEY)}`
            text += `endpoint='${codes[currentPage - 1].codeEndpoint}'\n`
            text += `method='${codes[currentPage - 1].codeMethod}'\n\n`
            text += '# Please update the output path of image_out\n'
            text += `payload='${JSON.stringify(codes[currentPage - 1].codePayload, null, 2)}'\n\n`
            // eslint-disable-next-line no-template-curly-in-string
            text += '# ************************************\n'
            text += '# Call API\n'
            text += '# ************************************\n'
            text += getSyncCurl()

            var data = new Blob([text], { type: 'text/plain' })
            if (textFile !== null) {
                window.URL.revokeObjectURL(textFile)
            }
            textFile = window.URL.createObjectURL(data)
            return textFile
        } else {
            return ''
        }
    }

    function onPageInputChange (value) {
        // console.log(value);
        setPage(value)
    }

    function getText () {
        const newLine = copyText(text)
        success('The code is copied.', {
            actionLabel: 'Log in console',
            onAction: (e) => console.log(newLine),
            timeout: 5000
        })
    }

    if (inputFiles && inputFiles.length > 0 && codes && codes.length > 0) {
        return <React.Fragment>
            <center>
                <div className="adobe-skycity-code-pagination">
                    <Pagination
                        variant="explicit"
                        mode="primary"
                        onChange={onPageInputChange}
                        onNext={onPageInputChange}
                        onPrevious={onPageInputChange}
                        totalPages={codes.length}
                        defaultPage={currentPage} />
                </div>
            </center>
            <div className="adobe-skycity-code-preview">
                <SyntaxHighlighter lineNumberStyle={lineNumberStyle} showLineNumbers={showLineNumbers} language={language} style={style}>
                    {text}
                </SyntaxHighlighter>
            </div>
            <div className="adobe-skycity-button-right">
                <Button variant="cta" onClick={e => getText(e)} disabled={text === ''}>{__('btn_api_copy')}</Button>
                <Button variant="cta" onClick={e => downloadFile(textFile, __('batch_filename'))} disabled={text === ''}>{__('btn_api_download')}</Button>
            </div>
        </React.Fragment>
    } else {
        return null
    }
}
